import React, {

  useRef,
  useEffect,
  useState

} from "react";

import "./InflightRouteBar.css";
export default function InflightRouteBar({

showUndo = false,
onUndoAmendment = () => {},

onExecuteDeparture = () => {},

onInsertBefore = () => {},

onInsertAfter = () => {},

onDeleteFix = () => {},

  origin,

  routeStructure = {},

  filedRoute = [],

  activeRoute = [],

  waypointObjects = [],


  currentLegIndex = 0,

  onTokenClick = () => {},

  onDirectTo = () => {},

  availableRunways = [],

  availableTransitions = [],

  availableApproaches = [],

  onArrivalRunwaySelect = () => {},

  onTransitionSelect = () => {},

  onApproachSelect = () => {},

  selectedArrivalRunway = null,

  selectedArrivalTransition = null,

  selectedApproach = null,

  selectedArrivalToken = null,

  onExecuteArrival = () => {},

  onArrivalTokenSelect = () => {},

  // =====================================
  // ✈️ CENTRALIZED PROCEDURE STATE
  // =====================================

  procedureConfig = {},

  updateArrivalProcedure = () => {},

  updateDepartureProcedure = () => {}

}) {

  const [

  insertFix,

  setInsertFix

] = useState("");

  const [

  showAddBeforeBox,

  setShowAddBeforeBox

] = useState(false);

const [

  showAddAfterBox,

  setShowAddAfterBox

] = useState(false);


  const [

  selectedToken,

  setSelectedToken

] = useState(null);

const [

  selectedIndex,

  setSelectedIndex

] = useState(null);

  const getFlightPhase = (index) => {

  const wp =
    waypointObjects[index - 1];

  if (!wp)
    return "airport";

  if (
    wp.procedure_type === "SID"
  ) {
    return "sid";
  }

  if (
    wp.procedure_type === "STAR"
  ) {
    return "star";
  }

  if (
    wp.procedure_type === "APPROACH"
  ) {
    return "approach";
  }

  return "enroute";
};

  const [
  availableSids,
  setAvailableSids
] = useState([]);

  const [

  sidRunways,

  setSidRunways

] = useState([]);

const [

  sidTransitions,

  setSidTransitions

] = useState([]);

  const [

  departurePanelOpen,

  setDeparturePanelOpen

] = useState(false);

  const [

  selectedProcedure,

  setSelectedProcedure

] = useState(null);

  const [

  filedRouteEditorOpen,

  setFiledRouteEditorOpen

] = useState(false);

  const [

  selectedFiledToken,

  setSelectedFiledToken

] = useState(null);

  const arrivalConfig =
  procedureConfig?.arrival || {};

  const routeBarRef = useRef(null);

  const activeTokenRef = useRef(null);

  const [arrivalPanelOpen, setArrivalPanelOpen] =
    useState(false);



  const scrollLeft = () => {

    routeBarRef.current?.scrollBy({

      left: -300,

      behavior: "smooth"
    });
  };

  const scrollRight = () => {

    routeBarRef.current?.scrollBy({

      left: 300,

      behavior: "smooth"
    });
  };

    const selectedWaypoint =

  selectedIndex !== null

    ? waypointObjects[
        selectedIndex - 1
      ]

    : null;


  useEffect(() => {

  console.log(
    "🚨 INFLIGHT WAYPOINT OBJECTS",
    waypointObjects?.slice(0, 10)
  );

}, [waypointObjects]);

  useEffect(() => {

  if (!departurePanelOpen) return;

  updateDepartureProcedure({

    sid:

      routeStructure
        ?.departure
        ?.sid || "",

    runway:

      routeStructure
        ?.departure
        ?.runway || "",

    transition:

      routeStructure
        ?.departure
        ?.transition || ""

  });

}, [

  departurePanelOpen

]);

useEffect(() => {

  if (
    !departurePanelOpen
  ) return;

  const airport =

    routeStructure
      ?.filedTokens?.[0];

  if (!airport) return;

  fetch(

    `https://ficon-x.com/route/list_cifp_sids/${airport}`

  )

  .then(async res => {

    const text =
      await res.text();

    console.log(
      "🚨 SID LIST RESPONSE",
      text
    );

    return JSON.parse(
      text
    );

  })

  .then(data => {

    console.log(
      "🛫 AVAILABLE SIDS",
      data
    );

    setAvailableSids(
      data.sids || []
    );

  })

  .catch(err => {

    console.error(
      "❌ SID LIST ERROR",
      err
    );

  });

}, [

  departurePanelOpen,

  routeStructure

]);

useEffect(() => {

  if (
    !departurePanelOpen
  ) return;

  const sid =
    routeStructure
      ?.departure
      ?.sid;

  if (!sid) return;

  const airport =

    routeStructure
      ?.filedTokens?.[0];

  if (!airport) return;

  fetch(

    `https://ficon-x.com/route/list_cifp_sid_transitions/${airport}/${sid}`

  )

    .then(async res => {

      const text =
        await res.text();

      console.log(
        "🚨 SID TRANSITION RESPONSE",
        text
      );

      try {

        return JSON.parse(
          text
        );

      }

      catch (err) {

        console.error(
          "🚨 BAD SID TRANSITION JSON",
          text
        );

        return {
          transitions: []
        };

      }

    })

    .then(data => {

      console.log(
        "🛫 SID TRANSITIONS",
        data
      );

      setSidTransitions(
        data.transitions || []
      );

    })

    .catch(err => {

      console.error(
        "🚨 SID TRANSITION FETCH ERROR",
        err
      );

    });

}, [

  departurePanelOpen,

  routeStructure,

  origin

]);

  useEffect(() => {

  if (
    !departurePanelOpen
  ) return;

  const sid =
    routeStructure
      ?.departure
      ?.sid;

  if (!sid) return;

  const airport =

    routeStructure
      ?.filedTokens?.[0];

  if (!airport) return;

  fetch(

  `https://ficon-x.com/route/list_cifp_sid_runways/${airport}/${sid}`

)

  .then(async res => {

  const text =
    await res.text();

  console.log(
    "🚨 SID RUNWAY RESPONSE",
    text
  );

  return JSON.parse(
    text
  );

})

    .then(data => {

      console.log(
        "🛫 SID RUNWAYS",
        data
      );

      setSidRunways(
        data.runways || []
      );

    });

}, [

  departurePanelOpen,

  routeStructure,

  origin

]);

  // =====================================
  // 🟣 AUTO-SCROLL ACTIVE TOKEN
  // =====================================

  useEffect(() => {

    if (!activeTokenRef.current) return;

    activeTokenRef.current.scrollIntoView({

      behavior: "smooth",

      inline: "center",

      block: "nearest"
    });

  }, [currentLegIndex]);

  // =====================================
  // 🛬 STAR TOKEN DETECTION
  // =====================================

  const isStarToken = (token) => {

    if (!token) return false;

    return /^[A-Z]{5}\d[A-Z]?$/.test(token);
  };

  // =====================================
  // 🛬 TOKEN CLICK HANDLER
  // =====================================

  const handleTokenClick = (

    token,
    index

  ) => {

  if (isStarToken(token)) {

    onArrivalTokenSelect(token);

    setArrivalPanelOpen(true);

    return;
  }

    onTokenClick(token, index);
  };

  const getTokenType = (token) => {

  if (!token)
    return "UNKNOWN";

  if (/^J\d+$/.test(token))
    return "AIRWAY";

  if (/^[VQT]\d+$/.test(token))
    return "AIRWAY";

  if (/^[A-Z]{5}\d[A-Z]?$/.test(token)) {

    if (
      token === procedureConfig?.arrival?.star ||
      token.startsWith(
        procedureConfig?.arrival?.star || ""
      )
    ) {

      return "STAR";
    }

    if (
      token === procedureConfig?.departure?.sid ||
      token.startsWith(
        procedureConfig?.departure?.sid || ""
      )
    ) {

      return "SID";
    }

    return "PROCEDURE";
  }

  if (/^K[A-Z]{3}$/.test(token))
    return "AIRPORT";

  return "FIX";
};

console.log(
  "🚨 PROCEDURE CONFIG IN ROUTEBAR",
  procedureConfig
);

console.log(
  "🚨 ROUTE STRUCTURE",
  routeStructure
);

return (

  <>

    <div className="route-stack">

      <div className="procedure-header">

<div



  className="procedure-chip departure"

  onClick={() => {

    setDeparturePanelOpen(
      true
    );

  }}

>

  🛫

  {" "}

  {routeStructure?.departure?.sid || "--"}

  {" "}

  {routeStructure?.departure?.runway || ""}

</div>

<div

  className="procedure-chip arrival"

  onClick={() => {

    console.log(
      "🛬 ARRIVAL CLICKED"
    );

    setArrivalPanelOpen(
      true
    );

  }}

>

  🛬

  {" "}

  {routeStructure?.arrival?.star || "--"}

  {" "}

  {routeStructure?.arrival?.transition || ""}

</div>

</div>

      {console.log(
        "🚨 FILED ROUTE RENDERING",
        filedRoute
      )}

      <div className="filed-route-strip">

        <span className="filed-route-label">
          FILED
        </span>

        <div className="filed-route-token-container">

{filedRoute?.map((token, idx) => (

<div

  key={idx}

  className={`filed-route-token

    ${
      selectedFiledToken?.index === idx
        ? "selected"
        : ""
    }
  `}

onClick={() => {

  // =====================================
  // 📋 FILED ROUTE TOKEN TOGGLE
  //
  // Click once  = open amendment menu
  // Click again = close amendment menu
  // =====================================

  if (
    selectedFiledToken?.index === idx
  ) {

    setSelectedFiledToken(
      null
    );

    return;
  }

  setSelectedFiledToken({

    token,

    index: idx

  });

}}

>

    {token}

  </div>

))}
        </div>

</div>
{selectedProcedure && (

  <div className="filed-token-menu">

    <div className="filed-token-title">

      {

        selectedProcedure.type === "SID"

          ? routeStructure?.departure?.sid

          : routeStructure?.arrival?.star

      }

    </div>

    {

      selectedProcedure.type === "SID"

      &&

      <button

        className="filed-menu-btn"

      >

        Edit SID

      </button>

    }

    {

      selectedProcedure.type === "STAR"

      &&

      <button

        className="filed-menu-btn"

        onClick={() => {

          setArrivalPanelOpen(
            true
          );

        }}

      >

        Edit STAR

      </button>

    }

  </div>

)}

{selectedFiledToken && (

  <div className="filed-token-menu">

<div className="filed-token-title">

  {selectedFiledToken.token}

  {" • "}

  {getTokenType(
    selectedFiledToken.token
  )}

</div>



{getTokenType(
  selectedFiledToken.token
) === "AIRWAY" && (

  <>

    <button className="filed-menu-btn">

      Replace Airway

    </button>

    <button className="filed-menu-btn">

      Delete Airway

    </button>

  </>

)}

{getTokenType(
  selectedFiledToken.token
) === "FIX" && (

  <>

    <button className="filed-menu-btn">

      Direct To

    </button>

    <button className="filed-menu-btn">

      Insert Before

    </button>

    <button className="filed-menu-btn">

      Insert After

    </button>

  </>

)}

{getTokenType(
  selectedFiledToken.token
) === "STAR" && (

  <>

    <button

      className="filed-menu-btn"

      onClick={() => {

      setArrivalPanelOpen(
        true
      );

      setSelectedFiledToken(
        null
      );

      setSelectedProcedure({

        type: "STAR"

      });

      }}

    >

      Edit STAR

    </button>

    <button className="filed-menu-btn">

      Change Transition

    </button>

    <button className="filed-menu-btn">

      Remove STAR

    </button>

  </>

)}

{getTokenType(
  selectedFiledToken.token
) === "SID" && (

  <>

    <button className="filed-menu-btn">

      Edit SID

    </button>

    <button className="filed-menu-btn">

      Change Runway

    </button>

    <button className="filed-menu-btn">

      Change Transition

    </button>

    <button className="filed-menu-btn">

      Remove SID

    </button>

  </>

)}

{getTokenType(
  selectedFiledToken.token
) === "AIRPORT" && (

  <>

    <button className="filed-menu-btn">

      Airport Info

    </button>

  </>

)}

  </div>

)}

<div className="route-strip-wrapper">

        <button
          className="route-scroll-btn"
          onClick={scrollLeft}
        >
          ◀
        </button>


        <div

          ref={routeBarRef}

className="inflight-route-bar"
>

  {activeRoute.map((token, index) => {

const wp =
  waypointObjects[index - 1];

    if (index < 15) {

      console.log(
        "🚨 TOKEN MATCH",
        index,
        token,
        wp?.id,
        wp?.procedure_name,
        wp?.procedure_type
      );

    }

    const isCompleted =
      index < currentLegIndex;

    const isActive =
      index === currentLegIndex + 1;

    const isStar =
      isStarToken(token);

    return (

              <div

                key={index}

                ref={
                  isActive
                    ? activeTokenRef
                    : null
                }

className={`route-token

  phase-${getFlightPhase(index)}

  ${isCompleted ? "completed" : ""}

  ${isActive ? "active" : ""}

  ${
    selectedIndex === index
      ? "selected"
      : ""
  }
`}

onClick={() => {

  // 🔥 TOGGLE OFF
  if (
    selectedIndex === index
  ) {

    setSelectedToken(
      null
    );

    setSelectedIndex(
      null
    );

    return;
  }

  // 🔥 OPEN PANEL
  setSelectedToken(
    token
  );

  setSelectedIndex(
    index
  );

  handleTokenClick(
    token,
    index
  );

}}

>

  {token}

</div>

);

})}

</div>

<button

  className="route-scroll-btn"

  onClick={scrollRight}

>
  ▶
</button>

{showUndo && (

  <button

    className="route-scroll-btn"

    onClick={() =>
      onUndoAmendment()
    }

    title="Undo Route Amendment"

  >
    ↶
  </button>

)}

</div>

{selectedToken && (

  <div className="fix-management-panel">

    <div className="fix-management-title">
      FIX MANAGEMENT
    </div>

    <div className="fix-management-row">

      <span>FIX</span>

      <span>
        {selectedToken}
      </span>

    </div>

    <div className="fix-management-row">

      <span>TYPE</span>

      <span>
        {selectedWaypoint?.procedure_type ||
          "ENROUTE"}
      </span>

    </div>

    <div className="fix-management-row">

      <span>PROC</span>

      <span>
        {selectedWaypoint?.procedure_name ||
          "NONE"}
      </span>

    </div>

    <div className="fix-management-actions">

<button
  className="arrival-option-btn"
  onClick={() =>
    onDirectTo(
      selectedToken,
      selectedIndex,
      () => {

        setSelectedToken(null);

        setSelectedIndex(null);

      }
    )
  }
>
  DIRECT TO
</button>

<button
  className="arrival-option-btn"
  onClick={() =>
    onDeleteFix(
      selectedToken,
      selectedIndex,

      () => {

        setSelectedToken(null);

        setSelectedIndex(null);

      }
    )
  }
>
  DELETE FIX
</button>

<button
  className="arrival-option-btn"
  onClick={() => {

    setShowAddBeforeBox(
      prev => !prev
    );

    setShowAddAfterBox(
      false
    );

  }}
>
  ➕ ADD BEFORE
</button>

<button
  className="arrival-option-btn"
  onClick={() => {

    setShowAddAfterBox(
      prev => !prev
    );

    setShowAddBeforeBox(
      false
    );

  }}
>
  ➕ ADD AFTER
</button>

</div>



  </div>

)}
{showAddBeforeBox && (

  <div className="insert-fix-box">

    <input
      value={insertFix}
      onChange={(e) =>
        setInsertFix(
          e.target.value
        )
      }
      placeholder="Fix"
    />

<button
  onClick={() => {

    onInsertBefore(

      selectedToken,
      selectedIndex,
      insertFix

    );

    setShowAddBeforeBox(
      false
    );

    setShowAddAfterBox(
      false
    );

    setInsertFix(
      ""
    );

    setSelectedToken(
      null
    );

  }}
>
  ADD
</button>

  </div>

)}

{showAddAfterBox && (

  <div className="insert-fix-box">

    <input
      value={insertFix}
      onChange={(e) =>
        setInsertFix(
          e.target.value
        )
      }
      placeholder="Fix"
    />

<button
  onClick={() => {

    onInsertAfter(

      selectedToken,
      selectedIndex,
      insertFix

    );

    setShowAddBeforeBox(
      false
    );

    setShowAddAfterBox(
      false
    );

    setInsertFix(
      ""
    );

    setSelectedToken(
      null
    );

  }}
>
  ADD
</button>

  </div>

)}
{/* =====================================
    🛬 ARRIVAL MANAGEMENT PANEL
===================================== */}

      

      {/* =====================================
          🛬 ARRIVAL MANAGEMENT PANEL
      ====================================== */}

      {arrivalPanelOpen && (

        <div className="arrival-panel">

          <div className="arrival-panel-header">

            ✈️ Arrival Management

            <button

              className="arrival-close-btn"

              onClick={() =>
                setArrivalPanelOpen(false)
              }
            >
              ✕
            </button>

          </div>

          <div className="procedure-info-row">

            STAR:
            <span>
              {arrivalConfig.star}
            </span>

          </div>

          {/* =========================
              RUNWAYS
          ========================== */}

          <div className="arrival-section">

            <div className="arrival-section-title">

              ARRIVAL RUNWAY

            </div>

            <div className="arrival-button-grid">

              {availableRunways.map((rwy) => (

<button
  key={rwy}
  className={`arrival-option-btn ${
    arrivalConfig.runway === rwy ? "selected" : ""
  }`}
  onClick={() => {

    updateArrivalProcedure({

      star: arrivalConfig.star,
      runway: rwy,
      transition: arrivalConfig.transition,
      approach: arrivalConfig.approach,
      iaf: arrivalConfig.iaf

    });

  }}
>
  {rwy}
</button>
              ))}

            </div>

          </div>

          {/* =========================
              TRANSITIONS
          ========================== */}

          <div className="arrival-section">

            <div className="arrival-section-title">

              STAR TRANSITION

            </div>

            <div className="arrival-button-grid">

              {availableTransitions.map((transition) => (

<button

  key={transition}

  className={`arrival-option-btn

    ${
      arrivalConfig.transition === transition
        ? "selected"
        : ""
    }
  `}

  onClick={() =>
    onTransitionSelect(
      transition
    )
  }
>
  {transition}
</button>
              ))}

            </div>

          </div>

          {/* =========================
              APPROACHES
          ========================== */}

          <div className="arrival-section">

            <div className="arrival-section-title">

              APPROACH

            </div>

            <div className="arrival-button-grid">

              {availableApproaches.map((approach) => (

<button

  key={approach.value}

  className={`arrival-option-btn

    ${
      arrivalConfig.approach ===
      approach.value

        ? "selected"

        : ""
    }
  `}

  onClick={() =>
    onApproachSelect(
      approach.value
    )
  }
>
  {approach.label}

</button>

    ))}

            </div>

            {/* =====================================
                🚀 EXECUTE ARRIVAL
            ===================================== */}

<button
  className="execute-arrival-btn"
  onClick={() => {

    console.log("🛬 Closing Arrival Panel");

    setArrivalPanelOpen(false);

  }}
>
  DONE
</button>

          </div>

        </div>
      )}

    </div>

    

      

{departurePanelOpen && (

  <div className="departure-panel">

    <div className="arrival-panel-header">

      ✈️ Departure Management

      <button

        className="arrival-close-btn"

        onClick={() =>
          setDeparturePanelOpen(
            false
          )
        }

      >

        ✕

      </button>

    </div>

    <div
      className="procedure-info-row"
    >

      SID:

      <span>

        {
          routeStructure
            ?.departure
            ?.sid
        }

      </span>

    </div>

    <div
      className="procedure-info-row"
    >

      RUNWAY:

      <span>

        {
          routeStructure
            ?.departure
            ?.runway
        }

      </span>

    </div>

    <div
      className="procedure-info-row"
    >

      TRANSITION:

      <span>

        {
          routeStructure
            ?.departure
            ?.transition
            || "--"
        }

      </span>

    </div>

    <div className="arrival-section">

  <div className="arrival-section-title">

    AVAILABLE SIDS

  </div>

  <div className="arrival-button-grid">

    {availableSids.map((sid) => (

      <button

        key={sid}

        className={`arrival-option-btn

          ${
            procedureConfig?.departure?.sid === sid
              ? "selected"
              : ""
          }

        `}

        onClick={() => {

          updateDepartureProcedure({

            sid,

            runway:
              procedureConfig
                ?.departure
                ?.runway ||

              routeStructure
                ?.departure
                ?.runway,

            transition:
              routeStructure
                ?.departure
                ?.transition

          });

          console.log(
            "🛫 SID SELECTED",
            sid
          );

        }}

      >

        {sid}

      </button>

    ))}

  </div>

</div>

    {/* =========================
        SID RUNWAYS
    ========================== */}

    <div className="arrival-section">

      <div className="arrival-section-title">

        SID RUNWAYS

      </div>

      <div className="arrival-button-grid">

        {console.log(
          "🚨 SID RUNWAYS IN RENDER",
          sidRunways
        )}

        {sidRunways.map((rwy) => (

          <button

            key={rwy}

            className={`arrival-option-btn

              ${
                procedureConfig?.departure?.runway === rwy
                  ? "selected"
                  : ""
              }

            `}

            onClick={() => {

              console.log(
                "🛫 REQUESTED RUNWAY CHANGE",
                rwy
              );

updateDepartureProcedure({

  sid:

    procedureConfig
      ?.departure
      ?.sid ||

    routeStructure
      ?.departure
      ?.sid,

  transition:

    procedureConfig
      ?.departure
      ?.transition ||

    routeStructure
      ?.departure
      ?.transition,

  runway: rwy

});

            }}

          >

            {rwy}

          </button>

        ))}

      </div>

    </div>

    {/* =========================
        EXECUTE DEPARTURE
    ========================== */}

<button

  className="execute-arrival-btn"

  onClick={() => {

    const departureConfig = {

      ...routeStructure?.departure,

      ...procedureConfig?.departure

    };

    onExecuteDeparture(
      departureConfig
    );




  }}

>

  EXECUTE DEPARTURE

</button>

  </div>

)}




    </>

  );

}